const URL_CONSTANTS = {
  //Sign In & Sign Up
  CREATE_USER: 'userservice/createuser',
  GET_AUTHENTICATED_USER: 'userservice/getauthenticateduser/',

  //Dashboard
  GET_RECENT_DASHBOARD_DATA: "dataservice/getrecentdashboarddata/",
  GET_DSS_INSIGHT_BY_USER: "dataservice/getdssinsightsbyuser/",
  GET_FAV_SAMPLELOCATION_DATA: 'dataservice/getfavoritesamplelocation/',
  GET_LATEST_DATA_BY_SITE: 'dataservice/getlatestlocationsdatainsite/',
  UPLOAD_CSV: 'importservice/uploaddata',
  GET_BACKEND_VERSION: 'userservice/getbackendversion',
  GET_ALL_DATA_BY_SITE: 'dataservice/getsitedatapoints/',

  //Add Test Data
  GET_SIMPLE_SITE_LOCATION: "/dataservice/getsimplesitelocation/",
  GET_SITE_LOCATION_LIST: "/dataservice/getsitelocationlist/",
  GET_SAMPLE_POINT: 'dataservice/getsamplepoint/',

  //Test Plan
  GET_SIMPLE_SITE_TESTPLAN: 'dataservice/getsimpleworkflowlistpaginated',

  //Event Log
  ADD_EVENT_LOG_ENTRY: 'userservice/addeventlogentry',
  ADD_EVENT_LOG_ENTRY_ANONYMOUS: 'userservice/addanonymouseventlog',

  //EULA services
  GET_EULA: 'importservice/geteula',
  ADD_EULA: 'userservice/addeula',

  // Organization services
  GET_ALL_SITES_OF_ORG: 'organizationservice/getsitelistsimple/',
  ORG_SERVICE_PATH: 'organizationservice/api/organizations/',
  GET_INDUSTRIES_LIST: 'organizationservice/getindustrieslist/',
  GET_SITES: 'organizationservice/getsites/?companyId=',
  UPDATE_SITE: 'organizationservice/updatesite',
  DELETE_SITE: 'organizationservice/deletesite/?siteId=',
  GET_ALL_ORG_SITES: 'organizationservice/getsitesfulllist',
  GET_ALL_APPLICATION_LIST: 'organizationservice/getapplicationsfulllist/',
  ADD_SITE_COOWNERS: 'organizationservice/addsitecoowners/',
  REMOVE_SITE_COOWNERS: 'organizationservice/removesitecoowners/',
  GET_SITE_DSS_DETAILS: 'organizationservice/getdssapplicationdetails/',
  GET_ALL_SAMPLE_TYPES: 'sampletypes/',

  // User services
  GET_ALL_USERS_OF_ORG: 'userservice/getorgusers/',
  GET_ALL_USERS_LIST_OF_ORG: 'userservice/getuserlistpaginated/',

  GET_SIMPLE_USER: 'userservice/getsimpleuser/',
  GET_ROLES: 'userservice/roles/',
  GET_USER: 'userservice/getuser/',
  GET_USER_BY_ID: 'userservice/getuserbyid/',
  UPDATE_USER: 'userservice/updateuser',
  GET_SITE_USERS: 'userservice/getsiteusers/',
  GET_SITE_LIST: 'organizationservice/getsitelistpaginated',
  SHARE_SITE: 'userservice/createsitesharerequest/',
  DELETE_USER: 'userservice/deleteuser',

  RESET_PASSWORD_SEND_EMAIL: 'userservice/resetpassword/sendemail/',
  SEND_USERNAME_EMAIL: 'userservice/sendusername/',
  RESET_PASSWORD: 'userservice/resetpassword/',
  USER_SEND_EMAIL: 'userservice/sendemail/',
  SEND_SUPPORT_TICKET: 'userservice/sendsupportticket/',
  GET_LATEST_APP_VERSION: 'userservice/getlatestappversion/',

  GET_COMPLETE_USET_LIST: 'userservice/getCompleteUserList/',

  SET_ANALYZER_WARRANTY: 'userservice/setanalyzerwarranty/',
  GET_LATEST_BCA_APP_VERSION: 'userservice/getlatestappversion/BCA/',

  // Both services not used in current flow but are referenced
  GET_ANALYTIC_LIST: 'userservice/getanalyticscoflistpaginated/',
  GET_ANALYTIC_CONFIG: 'userservice/getanalytic/',

  // PBM
  READ_PBM: 'userservice/getcommand/',
  STORE_PBM: 'userservice/storecommand/',
  PBM_STATUS: 'userservice/status/',

  //Data services
  GET_EXISTING_WORKFLOWS: 'dataservice/getworkflowsitelistpaginated/',
  GET_COMPLETED_WORKFLOWS: 'dataservice/getworkflowdatapaginated/',
  GET_EXISTING_SAMPLE_POINTS: 'dataservice/getsamplepointspaginated/',
  GET_COMPLETED_SAMPLE_POINTS: 'dataservice/getdatapointspaginated/',
  GET_REPORT_LIST: 'dataservice/getreportrecurrencesitelistpaginated/',
  IMPORT_DATA: 'dataservice/generatedataimporttemplate/',
  EXPORT_DATA: 'dataservice/exportdata/',
  GET_EXPORT_SETTINGS: 'dataservice/getexportsettings',
  SAVE_EXPORT_SETTINGS: 'dataservice/saveexportsettings',
  GET_SUPPLEMENTAL_LIST: 'dataservice/getsuppdescipotrspaginated/',
  GET_DATA_POINTS_IN_RANGE: 'dataservice/getdatapointinrange/',
  GET_DASHBOARD_RECENT_DATA: 'dataservice/getrecentdatapoints/',
  GET_DASHBOARD_ROLLEDUP_RECENT_DATA: 'dataservice/getrolleduprecentdatapoints/',
  GET_COMPLETED_DATA: 'dataservice/getcompleteddata/',
  SET_RECENT_DATA_SUMMERY: 'dataservice/sendrecentdatasummery',
  GET_SUPP_DATA_DESCRIPTOR: 'dataservice/getsupplementaldatadescriptor/',
  GET_WORKFLOW: 'dataservice/getworkflow/',
  UPDATE_WORKFLOW: 'dataservice/updateworkflow',
  GET_WORKFLOW_DATA: 'dataservice/getworkflowdata/',
  CREATE_SUPP_DATA_DESCRIPTOR: 'dataservice/createsupplementaldatadescriptor/',
  ADD_WORKFLOW: 'dataservice/addworkflow',
  DELETE_WORKFLOW_DATA_POINT: 'dataservice/addworkflowdata/',
  ADD_WORKFLOW_DATA: 'dataservice/addworkflowdata/',
  GET_DATAPOINTS: '/getdatapoints',

  //Sample Point Factory URLs
  GET_SAMPLE_POINTS: 'dataservice/getsamplepoints/',
  CREATE_SAMPLE_POINT: 'dataservice/createsamplepoint',
  UPDATE_SAMPLE_POINT: 'dataservice/updatesamplepointtoobject',

  //TestKitFactory URLs
  GET_TEST_KITS: 'dataservice/gettestkits',
  GET_TEST_KIT: 'dataservice/gettestkit/',
  GET_TEST_KIT_SAMPLEPOINT_ID: 'dataservice/gettestkitwithcustomalarms/',
  GET_TEST_KITS_FULL_LIST: 'organizationservice/gettestkitlist',
  GET_TEST_KIT_DESCRIPTORS_LIST: 'dataservice/gettestkitdescriptorlist/?userId=',

  //WaterKitsFactory URLs
  GET_WATER_SOURCES: 'organizationservice/getwatersourcelist',

  //DataFactory URLs
  GET_WORKFLOW_DATA_BY_SITE: 'dataservice/getworkflowdatabysite/',
  SEARCH_TESTKIT_RESULTS_BY_SAMPLE_POINT: 'dataservice/searchtestKitresultsbysamplepoint/?samplePointId=',
  CREATE_TESTKIT_RESULT: 'dataservice/createtestkitresult',
  GET_DATA_POINT_RESULTS: 'dataservice/getdatapointresults/',
  CREATE_DATA_POINT_RESULT: 'dataservice/createdatapointresult/',
  GET_ALL_DATA_NEW: 'dataservice/getalluserdata/',

  UPDATE_ALARMS: 'dataservice/updatealarms',
  ADD_SUPP_ALARM: 'dataservice/addsuppalarm/',

  // help section links
  APP_WALKTHROUGH_LINK: 'knowledgebase/walkthrough/',

  // verify app versions service
  VERIFY_APP_VERSION: 'userservice/validateAppVersion/',

  // create bulk data point ws
  CREATE_BULK_DATAPOINTS: 'dataservice/createbulkdatapoints/',

  //get insight and actions of site
  GET_DSS_INSIGHT: 'dataservice/getDSSInsight/',
  RESET_OLD_USER_PASSWORD: 'userservice/resetmigrationpassword',
  CHECK_EMAIL_MIGRATION: 'userservice/verifymigration',
  SORT_SAMPLE_LOCATION: 'dataservice/sortsamplelocation',
  CREATE_AZURE_USER: 'userservice/createazureuser',

  GET_DATA_TYPE: 'dataservice/getdatatypelist/',
  GET_DATAPOINT_BY_TYPE: 'dataservice/getlatestdatapointbytype/',
  GET_ALARM_HISTORY: 'dataservice/gethistoricalalarmconfig',

  //Add test data micro services
  GET_SITE_LIST_BY_USERID: 'dataservice/getsitelist/',
  GET_SL_LIST_BY_SITEID: 'dataservice/getlocationlist/',
  GET_SAMPLE_LOCATION_LIST_BY_SITE_ID_PAGINATION: 'dataservice/getlocationlistpaginated/',

  GET_SITE_LIST_PAGINATED: 'dataservice/getsitespaginated',

  //Session and B2c
  GET_AUTH_CODE: 'organizationservice/token?code=',

  // dss
  GET_DSS_DATA: 'dataservice/getdssdata',
  GET_DSS_GRAPH: 'dataservice/alarmcount',
  GET_DSS_NOTIFICATION: 'dataservice/getdssnotification',
  RESET_DSS_NOTIFICATION: 'dataservice/resetdssnotification',

  //Upload and download template URL
  UPLOAD_TEMPLATE: 'importservice/uploaddata',
  DOWNLOAD_TEMPLATE: 'importservice/downloadtemplate',
  DOWNLOAD_REPORT_CSV: 'reportservice/v1/generate/csv',

  //Site report actions
  GET_SITE_REPORTS_LIST: 'dataservice/getreportdata/',
  ADD_REPORT: 'dataservice/addupdatereport',
  SHARE_REPORT: 'dataservice/sendReport',
  DOWNLOAD_REPORT: 'reportservice/v1/generateanalyticsreport/pdf',

  // Organization Management
  SAVE_ORGANIZATION: 'organizationservice/api/organizations',
  GET_ORG_LIST_PAGINATED: 'organizationservice/getorganizationlistpaginated',
  GET_ORG_DETAILS: 'organizationservice/getorganization/',
  GET_META_DATA_MICRO_SERVICE: 'organizationservice/getorganizationmetadata',

  // Groups management
  GET_USER_GROUPS: 'organizationservice/getgroups/',
  CREATE_A_GROUP: '/organizationservice/addgroup',
  DELETE_A_GROUP: '/organizationservice/removegroup',
  GET_A_SITE: 'organizationservice/api/organizations/1/sites/',
  EDIT_A_SITE: 'organizationservice/api/organizations/1/sites/',
  CREATE_NEW_SITE: '/organizationservice/api/organizations',
  DELETE_A_SITE: '/organizationservice/removesitefromgroup/',
  // Update the URL for MOVE_SITE when the API is ready
  MOVE_SITE: '/organizationservice/addsitetogroup/',
  SORT_ORDERS_SITES_GROUPS: 'organizationservice/setsiteorders',
  EDIT_A_GROUP: 'organizationservice/updategroup/',

  // SITE MANAGEMENT
  ADD_SITE_OWNER: '/organizationservice/addsitecoowners/',
  REMOVE_SITE_OWNER: '/organizationservice/removesitecoowners/',

  GET_TESTKITS_BY_ORG_ID: '/dataservice/gettestkits',
  ADD_NEW_LOCATION: '/dataservice/createsamplepointsimple',
  EDIT_LOCATION: '/dataservice/updatesamplepointsimple',

  SYNC_SERVICE_FLAG: '/userservice/updatelocalstorageflag/',

  // Table Columns:
  GET_TABLE_COLUMNS: '/organizationservice/gettablecolumnsettings/',
  POST_TABLE_COLUMNS: '/organizationservice/createupdatetablecolumnsettings',

  // Sync Service:
  UPLOAD_SYNC_DATA: '/dataservice/uploadsyncdata',

  // CoC Lab Services
  GET_COC_LABS: 'organizationservice/getcoclabs',
  GET_COC_PRESETS: 'organizationservice/getcocpresets/',
  GET_COC_GROUPS: 'organizationservice/getcocgroups/',
  GET_COC_PANEL_ANALYSES: 'organizationservice/getcocpanelanalyses/',
  GET_COC_FORMS: 'organizationservice/getcocforms',
  CREATE_COC_LAB_REQUEST: 'organizationservice/createcocform',
  GET_COC_SITES: 'dataservice/getcocsites',


  // Analyzer
  GET_ANALYZER_WARRANTIES: '/userservice/getanalyzerwarranties/',
}

export default URL_CONSTANTS;